import { UserDetails } from '@abvehicles/types/userDetails';
import { StateCreator } from 'zustand';

export interface YourDetailsSlice {
  userDetails: UserDetails;
  sessionId: string;
  caseReferenceId: string;
  updateSessionId: (sessionId: string) => void;
  updateUserDetails: (userDetails: UserDetails) => void;
  updateCaseReferenceId: (caseReferenceId: string) => void;
  resetYourDetails: () => void;
}

export const createYourDetailsSlice: StateCreator<
  YourDetailsSlice,
  [],
  [],
  YourDetailsSlice
> = (set) => ({
  sessionId: '',
  userDetails: {
    firstName: '',
    lastName: '',
    email: '',
    contactId: '',
  },
  caseReferenceId: '',
  updateSessionId: (sessionId) => set(() => ({ sessionId })),
  updateUserDetails: (userDetails) => set(() => ({ userDetails })),
  updateCaseReferenceId: (caseReferenceId) => set(() => ({ caseReferenceId })),
  resetYourDetails: () =>
    set(() => ({
      userDetails: {
        firstName: '',
        lastName: '',
        email: '',
        contactId: '',
      },
      sessionId: '',
    })),
});
